import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GeneralWPService } from "src/app/core/http/web/generalWp.service";

@Component({
  selector: 'app-motores',
  templateUrl: './motores.component.html',
  styleUrls: ['./motores.component.css']
})
export class MotoresComponent implements OnInit {
  
  public data: any;
  public loarChild: any;
  public loadPage: boolean;

  isSeguros = false;
  constructor(private router:Router, private wpServ: GeneralWPService) {
    let url = this.router.url;
    console.log("url en motores seguros: ", url)
    this.isSeguros = url.split('/')[2].includes('seguros');
    console.log ("isSeguros en motores seguros: ", this.isSeguros)
    this.getGeneralOptions();
   }

  ngOnInit() {
  }

  getGeneralOptions() {
    this.wpServ.getGeneralOptions().subscribe(
      data => {
        this.data = data.data;
        this.loadPage = true;
        this.loarChild = false;
      },
      err => {
        console.error("Error en serv getGeneralOptions", err);
        this.loadPage = true;
        this.loarChild = true;
      }
    );
  }

  showMoreInfo() {
    // console.log("MoreInfoShow");
  }

  pintaHeader(){
  let valueSeguros:boolean=false
  let valueVuelos:boolean=false
  valueVuelos= this.router.url.includes("vuelos/destinos");
  valueSeguros = this.router.url.includes('seguros/resultados');
    if(valueVuelos || valueSeguros){
      return true
    }else{
      return false
    }
  }

}
